//Import Libraries
import React, { useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Button from "@material-ui/core/Button";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import EditableTable from "./EditableTable";
import fieldsArr from "../fields";
import "../rociview.scss";
import { config } from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MetaSearchFilter from "./MetaSearchFilter";
import { useUserAuthentication } from "../../../utils/utils";
import { useHistory } from "react-router-dom";
import { ApprovalTable } from "../../../components/Approval/ApprovalTable";
import DynamicDialog from "../../../components/Dialog/Dialog";

let api = config.api.api_url;

function MainTemplateView(props) {
  const {
    user,
    match,
    updateSourceInputs,
    updateAlert,
    source_data,
    getSources,
    clearReduxState,
    loading,
    setLoading,
    isApproval,
    getApprovalData,
  } = props;

  // STATES
  const [isTableDataSaving, setIsTableDataSaving] = useState(false);
  const [isSearchFilterLoading, setIsSearchFilterLoading] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isEdit, setIsEdit] = useState(false);
  const [globalEdit, setGlobalEdit] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false);
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [isPlaceholderFetching, setIsPlaceholderFetching] = useState(false);
  const [isDynamicDialogOpen, setIsDynamicDialogOpen] = useState(false);
  const [dynamicDialogMessage, setDynamicDialogMessage] = useState();

  let history = useHistory();
  const URL = history?.location?.pathname;
  const Use_Case_Name = URL.split("/").pop();
  const { login } = useUserAuthentication();

  // FUNCTIONS

  const getData = (row) => {};

  const outlinedCNCButton = {
    borderColor: "#46596A",
    // background-color: #d7dadd,
    color: "#46596A",
    // width: '100%',
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    marginRight: "5px",
  };

  const containedButton = {
    color: "white",
    backgroundColor: "#46596A",
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    // marginLeft: "10px !important",
    marginRight: "5px",
  };

  const IS_ANY_ROWDATA_NULL = useMemo(() => {
    if (
      source_data.current_mapped_data &&
      source_data.current_mapped_data.length > 0 &&
      source_data.data.dropdown
    ) {
      const ExceptionKeys = [
        ...(source_data?.data?.dropdown?.metadata_filter || []),
      ];

      return source_data?.current_mapped_data.some((singleRowData) => {
        return Object.keys(singleRowData.rowData).every(
          (key) =>
            ExceptionKeys.includes(key) || singleRowData.rowData[key] === null,
        );
      });
    } else {
      return false;
    }
  }, [
    source_data.current_mapped_data,
    source_data.current_ssfFileId,
    source_data.current_filter_value,
  ]);

  const IS_ANY_RECORDS_EDITED = useMemo(() => {
    if (source_data?.current_filter_value === "Create new") return true;
    if (source_data.isAnyRecordDeleted) return true;
    return (
      source_data?.current_mapped_data?.some(
        (item) => item.isEdited === true,
      ) ?? false
    );
  }, [source_data.current_mapped_data, source_data.isAnyRecordDeleted]);

  //function to set page for changing table row
  const pageChange = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let page_props = {
    total: source_data.current_mapped_data
      ? Math.ceil(source_data.current_mapped_data.length / rowsPerPage)
      : 0,
    page: page,
    changePage: pageChange,
    rowsPerPage: rowsPerPage,
    handleChangeRowsPerPage: handleChangeRowsPerPage,
    show_pageOptions: true,
  };

  function cancelFunction() {
    setIsCancelDialogOpen(false);
    updateSourceInputs("isNewPowerBrandDropdownValue", false);
    updateSourceInputs("isNewPowerBrand_logs", []);
    // updateSourceInputs("data",[]);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("is_initial", true);
    getSources();
  }

  function mergeWithObj2Priority(obj1, obj2) {
    const commonKeys = Object.keys(obj1).filter((key) => key in obj2);

    if (commonKeys.length > 0) {
      // Merge and overwrite obj1 values with obj2 values for common keys
      return {
        ...obj1,
        ...obj2, // obj2 values take priority
      };
    } else {
      // No common keys – just merge all keys
      return {
        ...obj1,
        ...obj2,
      };
    }
  }

  const getSortedModifiedData = () => {
    const Temp_Modidified_Data = source_data.modified_mapped_data.map(
      (item) => {
        const samerecord = source_data.current_mapped_data.find((data) =>
          source_data?.data?.dropdown?.duplicate_validation_attributes?.every(
            (attr) => data.rowData[attr] === item.updated[attr],
          ),
        );
        return {
          ...item,
          isEdited: item.isEdited,
          isNew: item.isNew,
          updated: {
            ...item.updated,
            COUNTRY_CODE: source_data.current_country_code,
            CREATED_AT: item.isNew
              ? item.isNew
              : item?.updated?.CREATED_AT || "",
            CREATED_BY: item.isNew
              ? user.mail || ""
              : item.updated.CREATED_BY || "",
            UPDATED_BY: !item.isNew
              ? user.mail || ""
              : item.updated.UPDATED_BY || "",
            ISNEW: item?.updated?.ISNEW
              ? item.updated.ISNEW
              : item?.isNew || false,
            ISDELETED: item?.updated?.ISDELETED
              ? item.updated.ISDELETED
              : item?.isDeleted || false,
            ISEDITED: item?.updated?.ISEDITED
              ? item.updated.ISEDITED
              : item?.isEdited || false,
          },
        };
      },
    );

    // Merge the Actual and updated object of modified data
    const Temp_modified_data_map = source_data.modified_mapped_data.map(
      (item) => {
        return mergeWithObj2Priority(item.actual, item.updated);
      },
    );

    const Current_Mapped_Data_With_Country_Code =
      source_data.current_mapped_data.map((item) => {
        return {
          ...item,
          rowData: {
            ...item.rowData,
            COUNTRY_CODE: source_data.current_country_code,
            CREATED_AT: item.isNewData
              ? item.isNewData
              : item?.updated?.CREATED_AT || "",
            CREATED_BY: item.isNewData
              ? user.mail || ""
              : item.rowData.CREATED_BY || "",
            UPDATED_AT: item?.rowData?.UPDATED_AT || "",
            UPDATED_BY: !item.isNewData
              ? user.mail || ""
              : item.rowData.UPDATED_BY || "",
            ISNEW: item?.rowData?.ISNEW || false,
            ISDELETED: item?.rowData?.ISDELETED || false,
            ISEDITED: item?.rowData?.ISEDITED || false,
            EXISTING_GLOBAL_RETAILER:
              item?.rowData?.EXISTING_GLOBAL_RETAILER || null,
          },
        };
      });

    // Remove the data which is modified from the current mapped data
    const Changed_Rows_Removed_Data =
      Current_Mapped_Data_With_Country_Code.filter((item) => {
        const isDuplicate = Temp_modified_data_map.some((data) =>
          source_data.data.dropdown.duplicate_validation_attributes.every(
            (attribute) => item.rowData[attribute] === data[attribute],
          ),
        );

        // Keep only if it's NOT a duplicate
        return !isDuplicate;
      });

    // Structure the Changed_Rows_Removed_Data
    const Temp_UnChanged_Data_Two = Changed_Rows_Removed_Data.map((item) => {
      return {
        actual: item.rowData,
        updated: {
          ...item.rowData,
          UPDATED_BY: user?.mail || "",
        },
        isDeleted: false,
        isEdited: false,
        isNew: false,
      };
    });

    const MODIFIED_MAPPED_DATA = [
      ...Temp_Modidified_Data,
      ...Temp_UnChanged_Data_Two,
    ];

    // Sorting MODIFIED_MAPPED_DATA by making null as String (i.e, "null")
    const SORTED_MODIFIED_MAPPED_DATA = MODIFIED_MAPPED_DATA.map((item) => {
      const KEYS = Object.keys(item.updated);
      const Actual = {};
      const Updated = {};

      KEYS.forEach((key) => {
        Actual[key] =
          item.actual[key] === null || item.actual[key] === "null"
            ? null
            : item.actual[key];
        Updated[key] =
          item.updated[key] === null || item.updated[key] === "null"
            ? null
            : item.updated[key];
      });

      if (source_data.has_awaiting_data.has_records) {
        return {
          ...item,
          actual: item.isNew ? {} : Actual,
          updated: Updated,
          isEdited: item.isEdited,
          isNew: item.isNew,
        };
      } else {
        return {
          ...item,
          actual: item.isNew ? {} : Actual,
          updated: {
            ...Updated,
            USERID: user?.mail || "",
          },
          isEdited: item.isEdited,
          isNew: item.isNew,
        };
      }
    });

    const Final_SORTED_MODIFIED_MAPPED_DATA = SORTED_MODIFIED_MAPPED_DATA.map(
      (item) => {
        const Actual = item?.actual || {};
        const Updated = item?.updated || {};

        const ACTUAL_IF_TOP_LEVEL =
          Actual.IF_TOP_LEVEL_MARKET !== null &&
          Actual.IF_TOP_LEVEL_MARKET !== "null" &&
          Actual.IF_TOP_LEVEL_MARKET !== ""
            ? Actual.IF_TOP_LEVEL_MARKET === "Yes"
              ? true
              : false
            : false;

        const UPDATED_IF_TOP_LEVEL =
          Updated.IF_TOP_LEVEL_MARKET !== null &&
          Updated.IF_TOP_LEVEL_MARKET !== "null" &&
          Updated.IF_TOP_LEVEL_MARKET !== ""
            ? Updated.IF_TOP_LEVEL_MARKET === "Yes"
              ? true
              : false
            : false;
        return {
          ...item,
          actual: {
            ...item.actual,
            IF_TOP_LEVEL_MARKET: ACTUAL_IF_TOP_LEVEL,
          },
          updated: {
            ...item.updated,
            IF_TOP_LEVEL_MARKET: UPDATED_IF_TOP_LEVEL,
          },
        };
      },
    );

    return Final_SORTED_MODIFIED_MAPPED_DATA;
  };

  // Function with Mock Data for Calculated Expression validation Flow
  const onSave = async () => {
    setIsTableDataSaving(true);

    const MODIFIED_MAPPED_DATA = getSortedModifiedData();

    try {
      const params = new URLSearchParams({
        usecase_name: Use_Case_Name || "",
        source: source_data?.current_source || "",
        country_code: source_data?.current_country_code || "",
        fileid: source_data?.current_ssfFileId || "",
        userid: user?.mail || "",
      });
      const response = await fetch(
        api + `/local_reporting/add_awaiting_data?${params}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(MODIFIED_MAPPED_DATA),
          credentials: "include",
        },
      );

      updateAlert({
        open: true,
        message: "Validating the records",
        severity: "success",
        closeFlag: true,
      });
      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login();
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      // Check response for successful DB update
      if (data.statusCode === "harbor-200") {
        clearReduxState();
        getSources();

        // Toast OnSuccess
        updateAlert({
          open: true,
          message: "All the changes are saved & awaiting for approval",
          severity: "success",
          closeFlag: true,
        });
      } else {
        // RESPONSE DATA FROM BACKEND API
        const Response = data.validated_result;

        // STEP 1 = UPDATE CURRENT_MAPPED_DATA RECORDS WITH RESPECTIVE RECORD FROM ACTUAL_UPDATED_COMBINED_DATA
        const Sorted_Mapped_Data = source_data.current_mapped_data.map(
          (item) => {
            // COMPARE MAPPED_DATA WITH RESPONSE DATA AND UPDATE ITS IS_VALIDATED ATTRIBUTE
            const matchedData = Response.find((data) => {
              const Merged_Data =
                source_data.current_filter_value === "Existing"
                  ? mergeWithObj2Priority(data.actual, data.updated)
                  : data.updated;
              // Check if all duplicate validation attributes match
              return source_data.data.dropdown.duplicate_validation_attributes.every(
                (attribute) => {
                  return item.rowData[attribute] === Merged_Data[attribute];
                },
              );
            });

            return {
              ...item,
              isEdited: matchedData
                ? matchedData.isEdited === "true"
                  ? true
                  : false
                : item.isEdited,
              isValidated: matchedData
                ? matchedData.isValidation === "true"
                  ? true
                  : false
                : item.isValidated,
              errorMessage:
                matchedData.isValidation === "false"
                  ? matchedData.exception_details
                  : "",
            };
          },
        );

        // STEP 2 = SORTING THE Sorted_Mapped_Data By keeping the Items with isValidated = false at top
        const FINAL_SORTED_MAPPED_DATA = Sorted_Mapped_Data.sort((a, b) => {
          return a.isValidated - b.isValidated;
        });

        updateSourceInputs("current_mapped_data", FINAL_SORTED_MAPPED_DATA);
        updateSourceInputs("appliedFilters", []);
        updateSourceInputs("searchValue", "");
        updateSourceInputs("filtered_Rows", []);

        // Error Toast
        updateAlert({
          open: true,
          message: "There was an error in the expression validation",
          severity: "Failed ",
          closeFlag: true,
        });
      }
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }

    setIsTableDataSaving(false);
    setIsSaveDialogOpen(false);
  };

  const onSaveAwaitingData = async () => {
    setIsTableDataSaving(true);

    // Getting The MODIFIED_MAPPED_DATA with IS_EDITED ATTRIBUTE
    const MODIFIED_MAPPED_DATA = getSortedModifiedData();
    try {
      const params = new URLSearchParams({
        usecase_name: Use_Case_Name || "",
        source: source_data?.current_source || "",
        country_code: source_data?.current_country_code || "",
        fileid: source_data?.current_ssfFileId || "",
        userid: user?.mail || "",
      });
      const response = await fetch(
        api + `/local_reporting/update_awaiting_data?${params}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(MODIFIED_MAPPED_DATA),
          credentials: "include",
        },
      );

      updateAlert({
        open: true,
        message: "Validating the records",
        severity: "success",
        closeFlag: true,
      });
      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      // Check response for successful DB update
      if (data.statusCode === "harbor-200") {
        clearReduxState();
        getSources();

        // Toast OnSuccess
        updateAlert({
          open: true,
          message: "All the changes are saved & awaiting for approval",
          severity: "success",
          closeFlag: true,
        });
      } else {
        // RESPONSE DATA FROM BACKEND API
        const Response = data.validated_result;

        // STEP 1 = UPDATE CURRENT_MAPPED_DATA RECORDS WITH RESPECTIVE RECORD FROM ACTUAL_UPDATED_COMBINED_DATA
        const Sorted_Mapped_Data = source_data.current_mapped_data.map(
          (item) => {
            // COMPARE MAPPED_DATA WITH RESPONSE DATA AND UPDATE ITS IS_VALIDATED ATTRIBUTE
            const matchedData = Response.find((data) => {
              const Merged_Data =
                source_data.current_filter_value === "Existing"
                  ? mergeWithObj2Priority(data.actual, data.updated)
                  : data.updated;
              // Check if all duplicate validation attributes match
              return source_data.data.dropdown.duplicate_validation_attributes.every(
                (attribute) => {
                  return item.rowData[attribute] === Merged_Data[attribute];
                },
              );
            });

            return {
              ...item,
              isEdited: matchedData
                ? matchedData.isEdited === "true"
                  ? true
                  : false
                : item.isEdited,
              isValidated: matchedData
                ? matchedData.isValidation === "true"
                  ? true
                  : false
                : item.isValidated,
              errorMessage:
                matchedData.isValidation === "false"
                  ? matchedData.exception_details
                  : "",
            };
          },
        );

        // STEP 2 = SORTING THE Sorted_Mapped_Data By keeping the Items with isValidated = false at top
        const FINAL_SORTED_MAPPED_DATA = Sorted_Mapped_Data.sort((a, b) => {
          return a.isValidated - b.isValidated;
        });

        updateSourceInputs("current_mapped_data", FINAL_SORTED_MAPPED_DATA);
        updateSourceInputs("appliedFilters", []);
        updateSourceInputs("searchValue", "");
        updateSourceInputs("filtered_Rows", []);

        // Error Toast
        updateAlert({
          open: true,
          message: "There was an error in the expression validation",
          severity: "Failed ",
          closeFlag: true,
        });
      }
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }

    setIsTableDataSaving(false);
    setIsSaveDialogOpen(false);
  };

  const fetchMetaData = async (usecase_name) => {
    let dropdown_data = {};
    try {
      const params = new URLSearchParams({
        usecase_name: usecase_name || "",
      });
      const response = await fetch(
        api + `/local_reporting/getmetadata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return false;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Invalid API response format");
      }
      dropdown_data = data?.data || {};
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
      return { dropdown_data: {}, isSuccess: false };
    }

    return {
      dropdown_data: dropdown_data,
      isSuccess: true,
    };
  };

  const setMappedData = async (
    file_id,
    usecase_name,
    dataset,
    country_code,
  ) => {
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", true);
    const isDataFetched = await fetchMetaData(usecase_name);

    if (!isDataFetched || !isDataFetched.isSuccess) {
      updateSourceInputs("is_table_loading", false);
      return;
    }

    let filteredDatasetValue;
    let DownloadSampleData;
    let have_awaiting_records = {};

    const Meta_Filters = isDataFetched?.dropdown_data?.metadata_filters || [];

    try {
      const params = new URLSearchParams({
        usecase_name: usecase_name || "",
        source: dataset || "",
        country_code: country_code || "",
        fileid: file_id || "",
        userid: user.mail || "",
      });

      const response = await fetch(
        api + `/local_reporting/getfetchdata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (data?.statusCode === "harbor-204") {
        updateAlert({
          open: true,
          message: `Mappings not available in the gold template mapping`,
          severity: "warning",
          closeFlag: true,
        });
        updateSourceInputs("is_initial", true);
        updateSourceInputs("is_table_loading", true);
        return;
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      const UPDATED_DROPDOWN_DATA = {
        ...(source_data?.data || {}),
        dropdown: isDataFetched.dropdown_data.is_value_fetch
          ? {
              ...isDataFetched.dropdown_data,
              ...data.metadata,
            }
          : {
              ...isDataFetched.dropdown_data,
            },
      };

      updateSourceInputs("data", UPDATED_DROPDOWN_DATA);

      if (data && data.data) {
        const DATA = data.data[0];
        have_awaiting_records = {
          has_records: data.awaiting_data_present || false,
          has_access: data.statusCode === "harbor-201" ? true : false,
          editor: DATA?.username || "",
          approver: DATA?.approver || "",
        };
        updateSourceInputs("has_awaiting_data", have_awaiting_records);
        filteredDatasetValue = data.data;
      }

      DownloadSampleData = data?.sample_data || [];
    } catch (err) {
      updateAlert({
        open: true,
        message: err
          ? `API called Failed wit error: ${err.message || err}`
          : `Got an error in the API call. Please check`,
        severity: "Failed ",
        closeFlag: true,
      });
    }

    let val = filteredDatasetValue || [];
    let ITEM_ID = 0;
    const tableData =
      val &&
      val.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isNewData: false,
          isEdited: false,
          isValidated: true,
          isCheckedRow: false,
          isMappingTypeNew: false,
          errorMessage: "",
          rowData: item,
        };
        ITEM_ID++;
        return rowData;
      });

    const Final_Table_Data =
      tableData?.map((item) => {
        const rowData = item.rowData || {};
        const SORTED_IF_TOP_LEVEL_MARKET =
          rowData.IF_TOP_LEVEL_MARKET !== null &&
          rowData.IF_TOP_LEVEL_MARKET !== "null" &&
          rowData.IF_TOP_LEVEL_MARKET !== ""
            ? rowData.IF_TOP_LEVEL_MARKET === true ||
              rowData.IF_TOP_LEVEL_MARKET === "true"
              ? "Yes"
              : "No"
            : "No";
        return {
          ...item,
          rowData: {
            ...rowData,
            IF_TOP_LEVEL_MARKET: SORTED_IF_TOP_LEVEL_MARKET,
          },
        };
      }) ?? [];

    const SAMPLE_DOWNLOAD_FILE =
      DownloadSampleData?.map((item) => {
        let rowData = item;
        Object.keys(rowData).forEach((key) => {
          if (
            rowData[key] === "null" ||
            rowData[key] === undefined ||
            rowData[key] === null
          ) {
            rowData[key] = null;
          }
        });
        const Altered_RowData = rowData;

        if (source_data.current_source.toLowerCase() === "nielsen") {
          rowData = {
            ...Altered_RowData,
            // COUNTRY: source_data.current_country,
            [Meta_Filters?.[0]]: source_data.current_country_code,
            [Meta_Filters?.[1]]: file_id,
            [Meta_Filters[2]]: source_data.current_source,
          };
        } else {
          rowData = {
            ...Altered_RowData,
            [Meta_Filters?.[0]]: source_data.current_country,
            [Meta_Filters?.[1]]: file_id,
            [Meta_Filters[2]]: source_data.current_source,
          };
        }
        return rowData;
      }) ?? [];

    // TABLE_DROPDOWN_DATA
    updateSourceInputs("current_mapped_data", Final_Table_Data);
    updateSourceInputs("current_mapped_data_main", Final_Table_Data);
    updateSourceInputs("download_sample_file", SAMPLE_DOWNLOAD_FILE);

    if (have_awaiting_records.has_records) {
      setIsDynamicDialogOpen(true);
      setDynamicDialogMessage(
        have_awaiting_records.has_access
          ? "Your awaiting data available for this file_Id, Do you want to fetch ?"
          : `Awaiting data available for this SFF_File_Id. ${
              `${have_awaiting_records?.editor} ${
                have_awaiting_records?.editor.length > 1 ? "are" : "is"
              } ` || ""
            } the ${
              have_awaiting_records?.editor.length > 1 ? "editors" : "editor"
            } and ${
              `${have_awaiting_records?.approver} ${
                have_awaiting_records?.approver.length > 1 ? "are" : "is"
              } ` || ""
            } the ${
              have_awaiting_records?.approver.length > 1
                ? "approvers"
                : "approver"
            }. Kindly contact them for further assistance`,
      );
    } else {
      updateSourceInputs("is_table_loading", false);
    }
  };

  const fetchAwaitingRecords = async () => {
    setIsDynamicDialogOpen(false);

    let filteredDatasetValue;
    let DownloadSampleData;

    const Meta_Filters = source_data?.data?.dropdown?.metadata_filters || [];

    try {
      const params = new URLSearchParams({
        usecase_name: Use_Case_Name || "",
        source: source_data.current_source || "",
        country_code: source_data.current_country_code || "",
        fileid: source_data.current_ssfFileId || "",
        userid: user.mail || "",
      });

      const response = await fetch(
        api + `/local_reporting/get_awaiting_table_data?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (data?.statusCode === "harbor-204") {
        updateAlert({
          open: true,
          message: `Mappings not available in the gold template mapping`,
          severity: "warning",
          closeFlag: true,
        });
        updateSourceInputs("is_initial", true);
        updateSourceInputs("is_table_loading", false);
        return;
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      if (source_data.data.dropdown.is_value_fetch) {
        const VALUES_WITHOUT_NULL = Array.isArray(data.values_data)
          ? data.values_data.filter(
              (item) =>
                item !== null &&
                item !== "null" &&
                item !== "" &&
                item !== undefined,
            )
          : [];
        const UPDATED_DROPDOWN_DATA = {
          ...source_data.data,
          dropdown: {
            ...source_data.data.dropdown,
            HARBOR_VALUE: VALUES_WITHOUT_NULL,
          },
        };

        updateSourceInputs("data", UPDATED_DROPDOWN_DATA);
      }

      if (data && data.data) {
        filteredDatasetValue = data.data;
      }

      // DownloadSampleData = data?.sample_data || [];
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }

    let val = filteredDatasetValue;
    let ITEM_ID = 0;
    const tableData =
      val &&
      val.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isNewData: false,
          isEdited: false,
          isValidated: true,
          isCheckedRow: false,
          isMappingTypeNew: false,
          errorMessage: "",
          rowData: item,
        };
        ITEM_ID++;
        return rowData;
      });

    const Final_Table_Data = tableData.map((item) => {
      const rowData = item.rowData || {};
      const SORTED_IF_TOP_LEVEL_MARKET =
        rowData.IF_TOP_LEVEL_MARKET !== null &&
        rowData.IF_TOP_LEVEL_MARKET !== "null" &&
        rowData.IF_TOP_LEVEL_MARKET !== ""
          ? rowData.IF_TOP_LEVEL_MARKET === true ||
            rowData.IF_TOP_LEVEL_MARKET === "true"
            ? "Yes"
            : "No"
          : "No";
      return {
        ...item,
        rowData: {
          ...rowData,
          IF_TOP_LEVEL_MARKET: SORTED_IF_TOP_LEVEL_MARKET,
        },
      };
    });

    // TABLE_DROPDOWN_DATA
    updateSourceInputs("current_mapped_data", Final_Table_Data);
    updateSourceInputs("current_mapped_data_main", Final_Table_Data);

    updateSourceInputs("is_table_loading", false);
  };

  const setMappedDataCreateNew = async (
    dataset,
    country,
    country_code,
    ssf,
    version,
    target_gold_layer,
  ) => {
    setIsPlaceholderFetching(true);
    setIsSearchFilterLoading(true);
    let filteredDatasetValue;
    let DownloadSampleData;

    try {
      const params = new URLSearchParams({
        country: country || "",
        country_code: country_code || "",
        file_id: ssf || "",
        dataset_name: dataset || "",
        filtertype: "create_new",
        version_details: version || "",
        target_gold_layer: target_gold_layer || "",
      });
      const response = await fetch(
        api + `/local_reporting/fetchtabledata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (data?.statusCode === "harbor-204") {
        updateAlert({
          open: true,
          message: `Mappings not available in the gold template mapping`,
          severity: "warning",
          closeFlag: true,
        });
        setIsSearchFilterLoading(false);
        setIsPlaceholderFetching(false);
        return;
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      if (source_data.data.dropdown.is_value_fetch) {
        const VALUES_WITHOUT_NULL = Array.isArray(data.values_data)
          ? data.values_data.filter(
              (item) =>
                item !== null &&
                item !== "null" &&
                item !== "" &&
                item !== undefined,
            )
          : [];
        const UPDATED_DROPDOWN_DATA = {
          ...source_data.data,
          dropdown: {
            ...source_data.data.dropdown,
            HARBOR_VALUE: VALUES_WITHOUT_NULL,
          },
        };

        updateSourceInputs("data", UPDATED_DROPDOWN_DATA);
      }

      if (data && data.data) {
        filteredDatasetValue = data.data;
      }

      DownloadSampleData = data?.sample_data || [];
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }

    let val = DownloadSampleData;
    let ITEM_ID = 0;
    const tableData =
      val &&
      val.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isNewData: false,
          isEdited: false,
          isValidated: true,
          isCheckedRow: false,
          errorMessage: "",
          rowData: item,
        };
        ITEM_ID++;
        return rowData;
      });

    const MODIFIED_MAPPED_DATA = tableData.map((rowData) => {
      return {
        actual: {},
        updated: rowData.rowData,
        isEdited: false,
        isNew: true,
      };
    });

    const SAMPLE_DOWNLOAD_FILE = DownloadSampleData.map((item) => {
      let rowData = item;
      Object.keys(rowData).forEach((key) => {
        if (
          rowData[key] === "null" ||
          rowData[key] === undefined ||
          rowData[key] === null
        ) {
          rowData[key] = null;
        }
      });
      const Altered_RowData = rowData;

      if (source_data.current_source === "Nielsen") {
        rowData = {
          ...Altered_RowData,
          COUNTRY: source_data.current_country,
          COUNTRY_CODE: source_data.current_country_code,
          TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
          [source_data.data.dropdown.metadata_filter?.[1]]: ssf,
        };
      } else {
        rowData = {
          ...Altered_RowData,
          COUNTRY: source_data.current_country,
          TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
          [source_data.data.dropdown.metadata_filter?.[1]]: ssf,
        };
      }
      return rowData;
    });

    // TABLE_DROPDOWN_DATA
    updateSourceInputs("current_mapped_data", tableData);
    updateSourceInputs("current_mapped_data_main", tableData);
    updateSourceInputs("download_sample_file", SAMPLE_DOWNLOAD_FILE);
    updateSourceInputs("modified_mapped_data", MODIFIED_MAPPED_DATA);

    setIsSearchFilterLoading(false);
    setIsPlaceholderFetching(false);
  };

  const handleCreateNewRow = () => {
    setIsSearchFilterLoading(true);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    let filteredDatasetValue;
    let tableData;

    const Meta_Filters = source_data.data.dropdown.metadata_filter;
    const CURRENT_MAPPED_DATA = source_data.current_mapped_data;
    let NewRowData = source_data.data.dropdown.insert_column_attributes;
    NewRowData = {
      ...NewRowData,
      [Meta_Filters[0]]: source_data.current_country,
      [Meta_Filters[1]]: source_data.current_ssfFileId,
      [Meta_Filters[2]]: source_data.current_source,
      USERID: user?.mail || "",
    };
    filteredDatasetValue = [NewRowData, ...CURRENT_MAPPED_DATA];

    let val = filteredDatasetValue;
    let ITEM_ID = 0;
    tableData =
      val &&
      val.map((item) => {
        let rowData;
        if (item.rowData) {
          rowData = {
            ...item,
            item_Id: ITEM_ID,
          };
        } else {
          rowData = {
            item_Id: ITEM_ID,
            isEditing: true,
            isNewData: true,
            isEdited: false,
            isValidated: true,
            isCheckedRow: false,
            isMappingTypeNew: false,
            errorMessage: "",
            rowData: item,
          };
        }
        ITEM_ID++;
        return rowData;
      });

    // // TABLE_DROPDOWN_DATA
    updateSourceInputs("any_row_isEditing", true);
    updateSourceInputs("current_mapped_data", tableData);
    updateSourceInputs("isNewDataInserted", true);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    setIsSearchFilterLoading(false);
  };

  const handleSourceInput = (data, selectedRowsCount) => {
    updateSourceInputs("current_mapped_data", data);
    updateSourceInputs("checked_rows_count", selectedRowsCount);
  };

  const testRecords = (records) => {
    let MissingValues = {};
    const Current_Table_Data = records || [];

    const TABLE_HEAD_COLUMN_LIST =
      source_data?.data?.dropdown?.table_header_column_list || [];
    const EDIT_COLUMN_LIST =
      source_data?.data?.dropdown?.edit_model_column_list || [];
    const Mapping_Type_Field_Details =
      source_data?.data?.dropdown?.mapping_type_field_details || [];

    Current_Table_Data.forEach((item) => {
      TABLE_HEAD_COLUMN_LIST.forEach((column) => {
        // Skip if value is null
        if (
          !source_data?.data?.dropdown?.duplicate_validation_attributes?.includes(
            column.name,
          ) &&
          (item.rowData[column.name] === "null" ||
            item.rowData[column.name] === "" ||
            item.rowData[column.name] === null ||
            item.rowData[column.name]?.length === 0)
        ) {
          return true;
        }

        // Skip HARBOR_VALUE validation for mapped types
        if (
          column.name === "HARBOR_VALUE" &&
          Mapping_Type_Field_Details.includes(item.rowData.MAPPING_TYPE)
        ) {
          return; // skip to next column
        }

        // === DEPENDENT COLUMN CHECK ===
        if (column.is_dependent) {
          const Filtered_Dropdown_Data =
            source_data?.data?.dropdown?.[column.name] || [];
          const Parent_Column_Name = column.parent_column;
          const Parent_Column_Value = item.rowData?.[Parent_Column_Name];

          if (!Parent_Column_Name || !Parent_Column_Value) return;

          const Filtered_Final_Options = Filtered_Dropdown_Data.filter(
            (option) => option[Parent_Column_Name] === Parent_Column_Value,
          );

          if (!Filtered_Final_Options.length) return;

          const validOptions = Filtered_Final_Options[0][column.name] || [];
          const isValidated = validOptions.includes(item.rowData[column.name]);

          if (!isValidated) {
            MissingValues[column.name] = [
              ...(MissingValues[column.name] || []),
              item.rowData[column.name],
            ];
          }
          return;
        }

        // === NORMAL COLUMN VALIDATION ===
        const editableColumn = EDIT_COLUMN_LIST.find(
          (data) => data.name === column.name && data.type === "select",
        );

        if (editableColumn) {
          const IS_ARRAY = editableColumn.isArray;
          const DROPDOWN_DATA_NEW = source_data?.data?.dropdown || {};
          const Final_DropDown_Values = DROPDOWN_DATA_NEW[column.name] || [];

          let resultValid = false;

          if (IS_ARRAY) {
            if (Final_DropDown_Values.length === 0) {
              resultValid = true;
            } else {
              resultValid = Final_DropDown_Values.includes(
                item.rowData[column.name],
              );
            }
          } else {
            resultValid =
              column.name === "HARBOR_VALUE" &&
              Mapping_Type_Field_Details.includes(item.rowData.MAPPING_TYPE)
                ? true
                : Array.isArray(Final_DropDown_Values) &&
                  Final_DropDown_Values.includes(item.rowData[column.name]);
          }

          if (!resultValid) {
            MissingValues[column.name] = [
              ...(MissingValues[column.name] || []),
              item.rowData[column.name],
            ];
          }
        }
      });
    });

    return MissingValues;
  };

  function formatValidationErrorDetails(errorObj) {
    if (!errorObj || typeof errorObj !== "object") return "";

    return Object.entries(errorObj)
      .map(([key, values]) => {
        if (Array.isArray(values) && values.length > 0) {
          return `${key}: ${values.join(", ")}`;
        }
        return null;
      })
      .filter(Boolean)
      .join(" | ");
  }

  const handleValidateFileData = (tableData) => {
    updateAlert({
      open: true,
      message: "Validating row data's",
      severity: "success",
      closeFlag: true,
    });

    const Current_Table_Data = tableData;
    const TABLE_HEAD_COLUMN_LIST =
      source_data.data.dropdown.table_header_column_list;
    const EDIT_COLUMN_LIST = source_data.data.dropdown.edit_model_column_list;
    const Mapping_Type_Field_Details =
      source_data?.data?.dropdown?.mapping_type_field_details || [];

    // test
    const failedRecord = testRecords(Current_Table_Data);
    const errorDetails = formatValidationErrorDetails(failedRecord);

    const isValid = Current_Table_Data.every((item, indxxx) => {
      return TABLE_HEAD_COLUMN_LIST.every((column) => {
        if (
          !source_data?.data?.dropdown?.duplicate_validation_attributes?.includes(
            column.name,
          ) &&
          (item.rowData[column.name] === "null" ||
            item.rowData[column.name] === "" ||
            item.rowData[column.name] === null ||
            item.rowData[column.name]?.length === 0)
        ) {
          return true;
        }
        if (
          column.name === "HARBOR_VALUE" &&
          Mapping_Type_Field_Details &&
          Mapping_Type_Field_Details.length > 0 &&
          Mapping_Type_Field_Details?.includes(item.rowData.MAPPING_TYPE)
        ) {
          return true;
        }
        if (column.is_dependent) {
          const Filtered_Dropdown_Data = source_data.data.dropdown[column.name];
          const Parent_Column_Name = column.parent_column;
          const Parent_Column_Value = item.rowData[Parent_Column_Name];

          // CHECK IS VALID VALUE
          const Filtered_Final_Options =
            Parent_Column_Value !== null
              ? Filtered_Dropdown_Data.filter(
                  (option) =>
                    option[Parent_Column_Name] === Parent_Column_Value,
                )
              : [];

          const isValidated = Filtered_Final_Options[0][column.name].includes(
            item.rowData[column.name],
          );

          return isValidated;
        } else {
          let IS_ARRAY;
          let result = EDIT_COLUMN_LIST.find((data) => {
            if (column.name === data.name) {
              if (data.isArray) {
                IS_ARRAY = true;
              }
              return data.type === "select";
            }
            return false;
          });

          if (result && result.type === "select") {
            const DROPDOWN_DATA_NEW = source_data.data.dropdown;
            const Final_DropDown_Values =
              DROPDOWN_DATA_NEW?.[column.name] || [];

            // UNCOMMENT IF CASE SENSITIVE TEST IS NOT REQUIRED
            // const isValidated = Array.isArray(Final_DropDown_Values) && Final_DropDown_Values.some((option)=> option.toUpperCase() === item.rowData[column.name].toUpperCase() )

            let resultvalid;
            if (IS_ARRAY && Array.isArray(Final_DropDown_Values)) {
              if (Final_DropDown_Values.length === 0) {
                resultvalid = true;
              } else {
                const column_value = item.rowData[column.name];
                const value_result =
                  Final_DropDown_Values.includes(column_value);
                resultvalid = value_result;
              }
            } else {
              resultvalid =
                column.name === "HARBOR_VALUE" &&
                Mapping_Type_Field_Details.includes(item.rowData.MAPPING_TYPE)
                  ? true
                  : Array.isArray(Final_DropDown_Values) &&
                    Final_DropDown_Values.includes(item.rowData[column.name]);
            }

            return resultvalid;
          } else {
            return true;
          }
        }
      });
    });

    if (isValid) {
      updateAlert({
        open: true,
        message: "File data validated successfully",
        severity: "success",
        closeFlag: true,
      });
      updateSourceInputs("is_table_loading", false);
      setIsFileUploading(false);

      const MODIFIED_MAPPED_DATA = Current_Table_Data.map((item) => {
        return {
          actual: {},
          isNew: false,
          isEdited: true,
          updated: { ...(item?.rowData || {}) },
        };
      });

      updateSourceInputs("modified_mapped_data", MODIFIED_MAPPED_DATA);
      updateSourceInputs("current_mapped_data", tableData);
      updateSourceInputs("isFileUploaded", true);
    } else {
      updateSourceInputs("is_initial", true);
      updateAlert({
        open: true,
        message: `Validation Failed! Invalid column value found in these columns ---> ${errorDetails}`,
        severity: "success",
        closeFlag: true,
      });
    }

    setIsFileUploading(false);
  };

  const handleFileUpload = (records) => {
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", true);
    setIsFileUploading(true);

    const Meta_Filters = source_data.data.dropdown.metadata_filter;
    const Existing_Records = source_data.current_mapped_data;
    const XL_FILE_RECORDS = records.map((item) => {
      return {
        ...item,
        CREATED_AT: item.CREATED_AT || null,
        CREATED_BY: item.CREATED_BY || null,
        UPDATED_AT: item.UPDATED_AT || null,
        UPDATED_BY: item.UPDATED_BY || null,
      };
    });

    const FILTEREDRECORDS = XL_FILE_RECORDS.map((item, i) => {
      const existing_Data = Existing_Records?.[i];
      return { ...(existing_Data?.rowData || {}), ...item };
    });

    let ITEM_ID = 0;
    const tableData =
      FILTEREDRECORDS &&
      FILTEREDRECORDS.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isNewData: false,
          isEdited: false,
          isValidated: true,
          isCheckedRow: false,
          errorMessage: "",
          rowData: item,
        };
        ITEM_ID++;
        return rowData;
      });

    handleValidateFileData(tableData);
  };

  const handleDialogClose = () => {
    if (!isTableDataSaving) {
      setIsSaveDialogOpen(false);
    }
  };

  const handleDialogOpen = () => {
    setIsSaveDialogOpen(true);
  };

  const handleDynamicDialogClose = () => {
    setIsDynamicDialogOpen(false);
  };

  const handleDynamicDialogCancel = () => {
    handleDynamicDialogClose();
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
  };

  // CONSTANTS
  const SOURCE_DATASET_LIST =
    source_data?.current_mapped_source &&
    source_data?.current_mapped_source.map((data) => {
      return data.toString();
    });

  const SOURCE_DATA_SET_SELECTED =
    SOURCE_DATASET_LIST &&
    SOURCE_DATASET_LIST.map((data) => {
      return { label: data, value: data };
    });

  // USE EFFECTS
  useEffect(() => {
    if (
      source_data.current_category != "" &&
      source_data.current_source != ""
    ) {
      setPage(0);
    }
  }, [source_data.current_source, source_data.current_category]);

  return (
    <>
      <>
        {loading ? (
          <Loader />
        ) : isApproval ? (
          <ApprovalTable
            sourceData={source_data}
            user={user}
            login={login}
            updateAlert={updateAlert}
            getApprovalData={getApprovalData}
            usecase_name={Use_Case_Name}
          />
        ) : (
          <MetaSearchFilter
            loading={loading}
            setLoading={setLoading}
            setMappedData={setMappedData}
            setMappedDataCreateNew={setMappedDataCreateNew}
            isSearchFilterLoading={isSearchFilterLoading}
            handleFileUpload={handleFileUpload}
            isFileUploading={isFileUploading}
            isPlaceholderFetching={isPlaceholderFetching}
          />
        )}

        {/* Loader new code */}
        {!source_data.is_initial ? (
          !source_data.is_table_loading ? (
            <>
              <EditableTable
                initWithoutHead
                page_props={page_props}
                sourceDropdownData={source_data.data.dropdown}
                defaultData={source_data.current_mapped_data}
                checkedRowCount={source_data.checked_rows_count}
                getData={getData}
                handleFileUpload={handleFileUpload}
                isFileUploading={isFileUploading}
                fieldsArr={fieldsArr}
                rowsPerPage={rowsPerPage}
                setIsEdit={setIsEdit}
                setGlobalEdit={setGlobalEdit}
                page={page}
                setPage={setPage}
                setRowsPerPage={setRowsPerPage}
                updateSourceHandler={handleSourceInput}
                sourceDatasetSelected={SOURCE_DATA_SET_SELECTED}
                setIsSearchFilterLoading={setIsSearchFilterLoading}
                outlinedCNCButton={outlinedCNCButton}
                containedButton={containedButton}
              />

              {/* Action button and disclaimer */}
              <div>
                <div className="disclaimer">
                  {/* INSERT NEW BUTTON */}
                  <div>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      onClick={handleCreateNewRow}
                      disabled={isSearchFilterLoading || IS_ANY_ROWDATA_NULL}
                    >
                      <span>Insert new</span>
                    </Button>
                  </div>

                  {/* DISCLAIMER */}
                  <div>
                    {source_data?.data?.dropdown?.disclaimer_details
                      ?.is_Disclaimer_available &&
                      Array.isArray(
                        source_data?.data?.dropdown?.disclaimer_details
                          ?.disclaimer_text,
                      ) &&
                      source_data.data.dropdown.disclaimer_details
                        .disclaimer_text.length > 0 && (
                        <div style={{ display: "flex" }}>
                          <p
                            style={{
                              margin: "0px",
                            }}
                          >
                            Disclaimer:
                          </p>
                          <ul
                            style={{
                              listStyle:
                                source_data.data.dropdown.disclaimer_details
                                  .disclaimer_text.length > 1
                                  ? "outside"
                                  : "none",
                              margin: "0px",
                              marginLeft:
                                source_data.data.dropdown.disclaimer_details
                                  .disclaimer_text.length > 1
                                  ? "0px"
                                  : "-15px",
                            }}
                          >
                            {source_data.data.dropdown.disclaimer_details.disclaimer_text.map(
                              (text, idx) => (
                                <li key={idx}>{text}</li>
                              ),
                            )}
                          </ul>
                        </div>
                      )}
                  </div>
                </div>

                {/* ACTION BUTTONS */}
                <div className="action-buttons">
                  <div className="">
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsCancelDialogOpen(true)}
                      disabled={isTableDataSaving}
                    >
                      Cancel
                    </Button>

                    {IS_ANY_RECORDS_EDITED && (
                      <Button
                        disableFocusRipple
                        style={containedButton}
                        onClick={handleDialogOpen}
                        disabled={isTableDataSaving}
                      >
                        <span>Save</span>
                      </Button>
                    )}
                  </div>
                </div>
              </div>

              {/* SAVE DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isSaveDialogOpen}
                  onClose={handleDialogClose}
                >
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        The latest changes will be created as a new version. Do
                        you want to continue?
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={handleDialogClose}
                      disabled={isTableDataSaving}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      disabled={isTableDataSaving}
                      onClick={
                        source_data.has_awaiting_data.has_records
                          ? onSaveAwaitingData
                          : onSave
                      }
                    >
                      Continue
                      {isTableDataSaving && <Loader />}
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>

              {/* CANCEL DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isCancelDialogOpen}
                  onClose={() => setIsCancelDialogOpen(false)}
                >
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        The latest changes will be undone. Do you want to
                        continue?
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsCancelDialogOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      onClick={cancelFunction}
                    >
                      Continue
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </>
          ) : (
            <Loader />
          )
        ) : (
          <div style={{ textAlign: "center" }}>
            {/* Choose the above mapping filters */}
          </div>
        )}

        {
          <DynamicDialog
            openModal={isDynamicDialogOpen}
            closeModel={handleDynamicDialogClose}
            title={"Confirmation"}
            hasCustomCancelButton={true}
            content={
              <p style={{ fontSize: "16px", color: "black", marginTop: "6px" }}>
                {dynamicDialogMessage}
              </p>
            }
            actions={
              <>
                <Button
                  onClick={handleDynamicDialogCancel}
                  style={{
                    fontFamily: "Hind Siliguri",
                    fontSize: "12px",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {source_data.has_awaiting_data.has_access ? "Cancel" : "Ok"}
                </Button>
                {source_data.has_awaiting_data.has_access && (
                  <Button
                    onClick={fetchAwaitingRecords}
                    style={{
                      backgroundColor: "#46596A",
                      fontFamily: "Hind Siliguri",
                      fontSize: "12px",
                      fontWeight: "bold",
                      marginRight: "5px",
                      color: "white",
                    }}
                  >
                    fetch
                  </Button>
                )}
              </>
            }
          />
        }
      </>
    </>
  );
}

MainTemplateView.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  source_data: PropTypes.object,
  brand_data: PropTypes.object,
  cncData: PropTypes.object,
  updateAlert: PropTypes.func,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  // userData:state.cncStateData.user,
  cncData: state.cncinputs,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MainTemplateView),
);
